import React from 'react';


const Competition = () => {

    return (
        <div>
            <snap>Competition</snap>

        </div>
    )
}
export default Competition;